import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { errorShape } from 'utils/shapes';
import { GET_GAMES_QUERY } from 'utils/graphql/queries';
import { padNumber } from 'utils/functions';
import { getLastGame } from 'utils/localStorage';
import './ReportGameIssue.css';

const DESCRIPTION_LIMIT = 4000;
const ISSUE_TYPES = [
  'Frozen/Locked',
  'Game Kicks me out',
  'Score not updating',
  'Session Timeout',
  'Slow to load',
  "Won't Display Properly",
  "Won't load ",
  'Other'
];

class ReportGameIssue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      issueGame: '',
      issueType: '',
      issueDescription: '',
      reportId: null,
      submitting: false,
      submitted: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.formOpen && !this.props.formOpen) {
      this.resetForm();
    }
  }

  resetForm() {
    const curr = this.state;
    const newState = { submitted: false, issueGame: curr.issueGame };
    if (curr.reportId) {
      // Clear all input if this report was successfully submitted
      Object.assign(newState, {
        issueGame: '',
        issueType: '',
        issueDescription: '',
        reportId: null
      });
    }
    if ((!curr.issueDescription && !curr.issueType) || curr.reportId) {
      // Guess the game if the user hasn't modified the form
      const gameGuess = getLastGame();
      const games = this.props.games;
      if (!games || games.find(game => game.name === gameGuess)) {
        newState.issueGame = gameGuess;
      }
    }
    this.setState(newState);
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    const {
      submitted,
      submitting,
      issueDescription,
      issueType,
      issueGame
    } = this.state;
    let description = issueDescription.replace(/[\r]/g, '').trim();
    let gameName = issueGame.trim();

    if (
      !this.props.gamesLoading &&
      !submitted &&
      !submitting &&
      description &&
      description.length <= DESCRIPTION_LIMIT &&
      ISSUE_TYPES.indexOf(issueType) >= 0 &&
      gameName
    ) {
      this.props
        .addGameIssueReport({
          gameName: gameName,
          issueType: issueType,
          description: description
        })
        .then(resp => {
          this.setState({
            reportId:
              resp.data &&
              resp.data.addGameIssueReport &&
              resp.data.addGameIssueReport.id,
            submitting: false,
            submitted: true
          });
        })
        .catch(e => {
          this.setState({ reportId: null, submitting: false, submitted: true });
        });

      this.setState({ submitting: true });
    }

    event.preventDefault();
  }

  renderGameInput() {
    const { games, gamesLoading, gamesError } = this.props;

    if (gamesLoading) {
      return (
        <div className="select-loading">
          <i className="fa fa-spinner fa-pulse fa-fw" /> Loading...
        </div>
      );
    } else if (!gamesError && games && games.length) {
      return (
        <select
          name="issueGame"
          value={this.state.issueGame}
          onChange={this.handleInputChange}
          required
        >
          <option value="" disabled hidden>
            &lt;Please choose...&gt;
          </option>
          {games.map(g => (
            <option value={g.name} key={g.name}>
              {g.displayName}
            </option>
          ))}
          <option value="other">Other</option>
        </select>
      );
    } else {
      return (
        <input
          type="text"
          name="issueGame"
          value={this.state.issueGame}
          onChange={this.handleInputChange}
          required
        />
      );
    }
  }

  renderFormHeader() {
    return (
      <div className="form-header">
        Report Game Issue
        <button
          type="button"
          onClick={this.props.close}
          className="btn close-button"
        >
          —
        </button>
      </div>
    );
  }

  render() {
    const { supportOpen, formOpen, open, close } = this.props;
    const { issueDescription, issueType, submitting, submitted } = this.state;

    if (!supportOpen) {
      return null;
    } else if (!formOpen) {
      return (
        <div className="report-game-issue-container">
          <div className="report-button">
            <button onClick={open} className="btn btn-primary">
              Report Game Issue
            </button>
          </div>
        </div>
      );
    } else if (!submitted && !submitting) {
      const charsLeft = DESCRIPTION_LIMIT - issueDescription.length;
      const limitClass = `input-limit ${charsLeft < 100 ? 'near-limit' : ''}`;

      return (
        <div className="report-game-issue-container">
          <form onSubmit={this.handleSubmit}>
            <div className="report-button">
              <input
                type="submit"
                value="Submit Report"
                className="btn btn-primary"
              />
            </div>
            <div className="report-form">
              {this.renderFormHeader()}
              <div className="form-body">
                <label>
                  What game is affected:
                  {this.renderGameInput()}
                </label>
                <label>
                  What type of issue are you seeing:
                  <select
                    name="issueType"
                    value={issueType}
                    onChange={this.handleInputChange}
                    required
                  >
                    <option value="" disabled hidden>
                      &lt;Please choose...&gt;
                    </option>
                    {ISSUE_TYPES.map(t => (
                      <option value={t} key={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                </label>
                <label>
                  Please describe the issue: (*)
                  <textarea
                    name="issueDescription"
                    value={issueDescription}
                    onChange={this.handleInputChange}
                    required
                  />
                </label>
                <div className={limitClass}>
                  ({charsLeft} characters remaining)
                </div>
              </div>
            </div>
          </form>
        </div>
      );
    } else {
      return (
        <div className="report-game-issue-container">
          <div className="report-button">
            <button
              onClick={close}
              className="btn btn-primary"
              disabled={submitting}
            >
              Close
            </button>
          </div>
          <div className="report-form">
            {this.renderFormHeader()}
            {this.renderSubmittedBody()}
          </div>
        </div>
      );
    }
  }

  renderSubmittedBody() {
    const { submitting, reportId } = this.state;
    if (submitting) {
      return (
        <div className="form-body submitted">
          <div className="header">
            <i className="fa fa-spinner fa-pulse fa-fw" /> Submitting...
          </div>
        </div>
      );
    } else if (reportId) {
      return (
        <div className="form-body submitted">
          <div className="header">Thank you for your report!</div>
          <div>
            We appreciate you taking the time to inform us of this issue! Your
            report will be forwarded to our staff for investigation.
          </div>
          <div>Your unique report ID is #{padNumber(reportId, 4)}.</div>
        </div>
      );
    } else {
      return (
        <div className="form-body submitted">
          <div className="header">
            There was a problem submitting your report
          </div>
          <div>
            We apologize for the inconvenience. Please try again later, or
            please contact us through the support chat.
          </div>
        </div>
      );
    }
  }
}

ReportGameIssue.propTypes = {
  supportOpen: PropTypes.bool,
  formOpen: PropTypes.bool,
  close: PropTypes.func,
  open: PropTypes.func,
  gamesLoading: PropTypes.bool,
  gamesError: errorShape,
  games: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      name: PropTypes.string
    })
  )
};

const ADD_GAME_ISSUE_REPORT_MUTATION = gql`
  mutation MyAddGameIssueReport($input: AddGameIssueReport!) {
    addGameIssueReport(input: $input) {
      id
    }
  }
`;

export default compose(
  graphql(GET_GAMES_QUERY, {
    props: ({ ownProps, data }) => ({
      gamesLoading: data.loading,
      gamesError: data.error,
      games:
        !data.loading && data.games && data.games.games
          ? data.games.games
              .slice(0)
              .sort(({ displayName: a }, { displayName: b }) =>
                a.toLowerCase().localeCompare(b.toLowerCase())
              )
          : undefined
    })
  }),
  graphql(ADD_GAME_ISSUE_REPORT_MUTATION, {
    props: ({ ownProps, mutate }) => ({
      addGameIssueReport: input => mutate({ variables: { input: input } })
    })
  })
)(ReportGameIssue);



// WEBPACK FOOTER //
// ./src/containers/ReportGameIssue/index.js